import { Appendix } from "../../../../shared/entities/scripts/appendix";
import { Study } from "../../../../shared/entities/scripts/study";
import { GetDateFromString } from "../../../../shared/scripts/date-functions";
import { IGraphDataPoint } from "../../../../shared/scripts/graphing/graphing.entities";
import { ForecastsLookup } from "./forecasts.lookup";


export class ForecastGraphDataPoint implements IGraphDataPoint {
    PrimeId: number;
    AppendixId: number;
    AppendixIds: number[];
    Date: string;
    Count: number;
    Rate: number;
    TypeId: number; //1: ActiveSites, 2: Rand Participants, 3: IRB Submissions, 4: VITAL alternate
    IsOverall: number; //0: No, 1: Yes
    TimestampFirstDay: number;
    TimestampLastDay: number;

    PrimeContract: string;
    Appendix: string;
    //IsStudyWide: boolean = false;

    CountField: string;
    DayOfMonth: string;

    initialize(dayOfMonth: string = "last", countField: string = "Count"): void { 

        this.PrimeContract = Study.GetStudyName(this.PrimeId);
        this.DayOfMonth = dayOfMonth;
        this.CountField = countField;

        //if (this.AppendixId != null) {
        //    this.Appendix = Appendix.GetAppendixName(this.AppendixId);
        //    if (this.Appendix.includes("_ALL")) { this.IsStudyWide = true; }    
        //}

        let lastDate: Date = GetDateFromString(this.Date, "slash-month-day-year");
        this.TimestampLastDay = lastDate.getTime();

        let firstDate: Date = new Date(lastDate);
        firstDate.setDate(1);
        //this.Timestamp = GetDateFromString(this.Date, "slash-month-day-year").getTime();
        this.TimestampFirstDay = firstDate.getTime();

        //delete this.PrimeId;

    }

    getTimestamp(): number {
        if (this.DayOfMonth == "last") { return this.TimestampLastDay; }
        else { return this.TimestampFirstDay; }
    }

    getCount(): number {
        if (this.CountField == "rate") { return this.Rate; }
        else { return this.Count; }

    }
}